import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo_transparent",
  "use": "icon-logo_transparent-usage",
  "viewBox": "0 0 266 323",
  "content": "<symbol viewBox=\"0 0 266 323\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-logo_transparent\">\r\n<path d=\"M0 323V0L119.104 50.0286L143.422 204.971L167.243 70.4286L266 115.6V134.543L210.914 111.714L206.944 126.286L266 152.514V204.971L188.582 239.943L194.537 193.314L232.75 176.314L188.582 156.886L173.198 246.257L76.9216 287.057L46.153 204.971V303.086L0 323Z\" fill=\"#34363A\" fill-opacity=\"0.06\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol